"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeFormModal = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.isOpen, (0, fast_element_1.html) `
  <rws-modal header="knowledge.create" centerTop="false" :closeModal="${x => x.onCancel.bind(x)}">
    <div class="knowledge-form-modal-content">
      <div class="modal-body">
        <div class="container-fluid">
          <knowledge-form-content 
            :isModalMode="${() => true}"
            :formOverride="${x => x.payload ? x.payload : undefined}"
            @knowledge-saved="${(x, c) => x.handleKnowledgeSaved(c.event)}"
            @cancel="${(x, c) => x.onCancel()}">
          </knowledge-form-content>
        </div>
      </div>
    </div>
  </rws-modal>
`)}
`;
require("./styles/layout.scss");
const styles = T.css `@charset "UTF-8";
:host {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
}
:host .knowledge-form-modal-content {
  width: 100%;
  max-width: 1000px;
}
:host .knowledge-form-modal-content .modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host .knowledge-form-modal-content .modal-header .modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
}
:host .knowledge-form-modal-content .modal-header .btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  padding: 0;
  width: 1em;
  height: 1em;
}
:host .knowledge-form-modal-content .modal-header .btn-close:hover {
  opacity: 0.75;
}
:host .knowledge-form-modal-content .modal-header .btn-close::before {
  content: "×";
}
:host .knowledge-form-modal-content .modal-body {
  padding: 1.5rem;
  max-height: 70vh;
  overflow-y: auto;
}
:host .knowledge-form-modal-content .modal-body knowledge-form {
  display: block;
  width: 100%;
}
:host .knowledge-form-modal-content .modal-body knowledge-form .form-group {
  margin-bottom: 1rem;
}
:host .knowledge-form-modal-content .modal-body knowledge-form .form-group:last-child {
  margin-bottom: 0;
}
:host .knowledge-form-modal-content .modal-body knowledge-form .row {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
:host .knowledge-form-modal-content .modal-body knowledge-form .row .col-md-8,
:host .knowledge-form-modal-content .modal-body knowledge-form .row .col-md-4 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}`;
const shadowOptions = { "mode": "open" };
let KnowledgeFormModal = class KnowledgeFormModal extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.payload = {};
    }
    async connectedCallback() {
        super.connectedCallback();
    }
    handleKnowledgeSaved(event) {
        // Emit the event up to the parent component
        this.$emit('knowledge-created', event.detail);
        if (this.closeModal) {
            this.closeModal();
        }
    }
    onCancel() {
        if (this.closeModal) {
            this.closeModal();
        }
    }
};
exports.KnowledgeFormModal = KnowledgeFormModal;
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], KnowledgeFormModal.prototype, "isOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], KnowledgeFormModal.prototype, "closeModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object)
], KnowledgeFormModal.prototype, "payload", void 0);
exports.KnowledgeFormModal = KnowledgeFormModal = __decorate([
    (0, client_1.RWSView)('knowledge-form-modal', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], KnowledgeFormModal);
KnowledgeFormModal.defineComponent();
